import styled from 'styled-components';
import { mediaBreakpointMixin, Tabs } from '@zillow/constellation';

export const StyledPDFDocumentWrapper = styled.div`
  canvas {
    // using !important because library adds inline styles
    width: 100% !important;
    height: auto !important;
  }
`;

export const StyledTabPanel = styled(Tabs.Panel)`
  overflow: scroll;
  max-height: 612px;

  @media ${mediaBreakpointMixin('md_lte')} {
    max-height: calc(100vh - 235px);
  }
`;
